import validate from "/app/node_modules/.pnpm/nuxt@4.0.3_@parcel+watcher@2.5.1_@types+node@22.13.16_@vue+compiler-sfc@3.5.20_db0@0.3._72b551815f03e796a35b7f031d16d25c/node_modules/nuxt/dist/pages/runtime/validate.js";
import _1_45redirects_45global from "/app/middleware/1.redirects.global.ts";
import _2_45errors_45global from "/app/middleware/2.errors.global.ts";
import _3_45redirect_45trailing_45slash_45global from "/app/middleware/3.redirectTrailingSlash.global.ts";
import _4_45sql_45injection_45protection_45global from "/app/middleware/4.sqlInjectionProtection.global.ts";
import route_45global from "/app/middleware/route.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@4.0.3_@parcel+watcher@2.5.1_@types+node@22.13.16_@vue+compiler-sfc@3.5.20_db0@0.3._72b551815f03e796a35b7f031d16d25c/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _1_45redirects_45global,
  _2_45errors_45global,
  _3_45redirect_45trailing_45slash_45global,
  _4_45sql_45injection_45protection_45global,
  route_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "redirect-lp-pages": () => import("/app/middleware/redirectLpPages.ts")
}